// // src/modules/login/Callback.jsx
// import React, { useEffect } from 'react';
// import { useDispatch } from 'react-redux';
// import { userManager } from '../../utils/oidc';
// import { loginSuccess, logoutUser } from '@store/reducers/auth';
// import { useHistory } from 'react-router-dom';
// import { apiRoleMappingPagingAction } from '@app/store/reducers/apiRoleMapping';

// const Callback = () => {
//     const dispatch = useDispatch();
//     const history = useHistory();

//     useEffect(() => {
//         // userManager.signinRedirectCallback()
//         //   .then(user => {
//         //     // user.access_token, user.id_token, user.refresh_token, user.expires_in
//         //     dispatch(loginSuccess({
//         //       expiresAt:    user.expires_in * 1000 + Date.now()
//         //     }));
//         //     // document.getElementById('root').classList.remove('register-page', 'login-page', 'hold-transition');
//         //     history.replace('/');
//         //   })
//         //   .catch(err => {
//         //     console.error(err);
//         //     dispatch(logoutUser());
//         //     history.replace('/loginsso');
//         //   });

//         const isSilentRenew =
//             window.location.pathname.includes('silent-renew.html');
//         const callbackMethod = isSilentRenew
//             ? 'signinSilentCallback'
//             : 'signinRedirectCallback';

//         userManager[callbackMethod]()
//             .then((user) => {
//                 if (user) {
//                     dispatch(
//                         apiRoleMappingPagingAction({ PageIndex: 1, PageSize: 10000 })
//                     );

//                     dispatch(
//                         loginSuccess({
//                             access_token: user.access_token,
//                             id_token: user.id_token,
//                             refresh_token: user.refresh_token,
//                             expiresAt: user.expires_in * 1000 + Date.now()
//                         })
//                     );

//                     if (!isSilentRenew) {
//                         history.replace('/');
//                     }
//                 }
//             })
//             .catch((err) => {
//                 dispatch(logoutUser());
//                 if (!isSilentRenew) {
//                     history.replace('/loginsso');
//                 }
//             });
//     }, [dispatch, history]);

//     return <div>Signing you in…</div>;
// };

// export default Callback;


// src/modules/login/Callback.jsx
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { userManager } from '@app/utils/oidc';
import { loginSuccess, logoutUser } from '@store/reducers/auth';
import { apiRoleMappingPagingAction } from '@app/store/reducers/apiRoleMapping';
import { persistor } from '@app/store/store';
import { BaseGatewayAuth } from '@app/utils/apiUrl';
import { FLASH_KEY } from '@app/utils/define';

const Callback = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    (async () => {
      const isSilentRenew = window.location.pathname.includes('silent-renew.html');
      const callbackMethod = isSilentRenew ? 'signinSilentCallback' : 'signinRedirectCallback';

      try {
        // 1) Lưu user OIDC vào storage
        const user = await userManager[callbackMethod]();
        if (!user) throw new Error('No user from OIDC callback');

        // 2) Đợi lấy APIRoleMapping xong
        //   - .unwrap() => fulfilled trả data, rejected ném lỗi (catch ở dưới)
        const result = await dispatch(
          apiRoleMappingPagingAction({ PageIndex: 1, PageSize: 10000 })
        ).unwrap();

        // 3) Chỉ loginSuccess khi mapping hợp lệ (có dữ liệu)
        const items = Array.isArray(result?.data) ? result.data : [];
        if (items.length === 0) throw new Error('no_mapping');

        // 4) OK → set auth state
        await dispatch(
          loginSuccess({
            access_token: user.access_token,
            id_token: user.id_token,
            refresh_token: user.refresh_token,
            expiresAt: user.expires_in * 1000 + Date.now()
          })
        );

        // Delay 3s để hiển thị màn hình loading
        await new Promise((resolve) => setTimeout(resolve, 3000));

        // 5) Điều hướng về trang chính (trừ silent renew)
        if (!isSilentRenew) history.replace('/');

      } catch (err) {
        // Mapping rỗng / callback lỗi → flash + purge + logout SSO
        try {
          localStorage.setItem(
            FLASH_KEY,
            JSON.stringify({ level: 'error', text: 'Tài khoản này không được sử dụng phần mềm này' })
          );
        } catch { }

        try {
          await persistor.flush();
          await persistor.purge();
        } catch { }

        dispatch(logoutUser());

        if (!isSilentRenew) {
          const returnUrl = encodeURIComponent(window.location.origin + '/logged-out');
          window.location.replace(
            `${BaseGatewayAuth}/connect/logout?post_logout_redirect_uri=${returnUrl}`
          );
        }
      }
    })();
  }, [dispatch, history]);

  return (
    <div style={styles.container}>
      <style>{`
        @keyframes slideRight {
          0% {
            left: -100px;
          }
          100% {
            left: 100%;
          }
        }
        @keyframes pulse {
          0%, 100% { opacity: 0.6; }
          50% { opacity: 1; }
        }
      `}</style>
      <div style={styles.card}>
        <div style={styles.logoTrack}>
          <img
            src="/img/logo_cntt_108.jpg"
            alt="Logo 108 Hospital"
            style={styles.logo}
          />
        </div>
        <h3 style={styles.title}>PHẦN MỀM QUẢN LÝ CÔNG VIỆC</h3>
        <div style={styles.loaderContainer}>
          <span style={styles.loaderText}>Đang xử lý đăng nhập...</span>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    width: '100vw',
    background: 'linear-gradient(135deg, #0d47a1 0%, #1565c0 50%, #1e88e5 100%)',
    fontFamily: "'Inter', 'Roboto', 'Helvetica Neue', sans-serif",
    margin: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 9999
  },
  card: {
    background: 'rgba(255, 255, 255, 0.1)',
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    borderRadius: '16px',
    padding: '40px',
    width: '420px',
    textAlign: 'center',
    boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.3)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  logoTrack: {
    width: '100%',
    height: '110px',
    background: '#ffffff',
    borderRadius: '12px',
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '25px',
    boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.1)'
  },
  logo: {
    height: '100px',
    position: 'absolute',
    top: '15px',
    animation: 'slideRight 3.5s linear infinite'
  },
  title: {
    color: '#ffffff',
    fontSize: '18px',
    fontWeight: '600',
    letterSpacing: '1px',
    marginBottom: '20px',
    textShadow: '0 2px 4px rgba(0,0,0,0.2)'
  },
  loaderContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  loaderText: {
    color: '#ffffff',
    fontSize: '15px',
    fontWeight: '500',
    letterSpacing: '0.5px',
    animation: 'pulse 1.8s infinite ease-in-out'
  }
};

export default Callback;
